














































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ICommentItem } from "@/api/types";
import { Icon } from "vant";
@Component({
  components: {
    vanIcon: Icon
  }
})
export default class CommentItem extends Vue {
  // themeColor这个属性是针对不同的区县 姓名 点赞等图标拥有不同的颜色
  @Prop({
    default: "#c32825"
  })
  private themeColor!: string;
  @Prop()
  private item!: ICommentItem;
  @Prop({ default: true })
  private isReply!: boolean;
  @Prop()
  private appId!: string | number;
  mounted() {
    //获取用户详情
  }
  get userAvatarDefault() {
    if (this.appId == 15) {
      // 北碚
      return require("../assets/user-img-beibei.png");
    } else if (this.appId == 33) {
      return require("../assets/jiulongpo/头像@2x.png");
    } else {
      return require("../assets/user-img.png");
    }
  }
  // 点赞触发
  doPraise(item: ICommentItem) {
    this.$emit("doPraise", item);
  }
  // 去评论页触发
  toCommentDetail() {
    this.$emit("toCommentDetail");
  }
  //图片预览事件
  toImagePreview(item: any) {
    this.$emit("toImagePreview", item);
  }
}
